import { action, computed, makeObservable, observable } from 'mobx';

import { IAccessibilityStore } from '../IAccessibilityStore';

export type LineHeightMultiplier = 1 | 1.5 | 2;

export class LineHeightStore implements IAccessibilityStore {
  lineHeightMultiplier: LineHeightMultiplier = 1;

  constructor() {
    makeObservable(this, {
      lineHeightMultiplier: observable,

      isDefaultLineHeight: computed,
      isMediumLineHeight: computed,
      isLargeLineHeight: computed,

      setLineHeightMultiplier: action.bound,
      reset: action.bound,
    });
  }

  get isDefaultLineHeight() {
    return this.lineHeightMultiplier === 1;
  }

  get isMediumLineHeight() {
    return this.lineHeightMultiplier === 1.5;
  }

  get isLargeLineHeight() {
    return this.lineHeightMultiplier === 2;
  }

  setLineHeightMultiplier(multiplier: LineHeightMultiplier) {
    this.lineHeightMultiplier = multiplier;
  }

  setLineHeightMedium = () => {
    this.setLineHeightMultiplier(1.5);
  };

  setLineHeightLarge = () => {
    this.setLineHeightMultiplier(2);
  };

  reset = () => {
    this.setLineHeightMultiplier(1);
  };
}
